import { render, staticRenderFns } from "./onebox-checkregister.vue?vue&type=template&id=3727820c&scoped=true&"
import script from "./onebox-checkregister.vue?vue&type=script&lang=js&"
export * from "./onebox-checkregister.vue?vue&type=script&lang=js&"
import style0 from "./onebox-checkregister.vue?vue&type=style&index=0&id=3727820c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3727820c",
  null
  
)

export default component.exports